import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import ConsentsEditContent from './ConsentsEditContent'
import * as consentActions from 'services/consents/actions'

const mapStateToProps = () => {
  return {}
}

const mapDispatchToActions = {
  ...consentActions,
  push,
}

export class ConsentsEditPage extends React.Component {
  static propTypes = {
    stageUnconsenteList: PropTypes.func,
    push: PropTypes.func,
  }

  handleSubmit = (values) => {
    this.props.stageUnconsenteList(values)
    this.props.push({ pathname: '/privacy_center/consents/decline' })
  }

  render () {
    return (
      <div className='consentspage mobile'>
        <ConsentsEditContent onSubmit={this.handleSubmit} />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(ConsentsEditPage)
